import Phaser from "phaser";
import React from "react";
import { useEffect, forwardRef, useRef, useState } from "react";
import PhaserProvider from "../PhaserProvider";
import RPFScene from "./RPFScene";

/**
 * Creates a new Phaser.Game with given arguments.
 * triggers functions to store game into context
 */
const Canvas = forwardRef(({ args, children }, canvasRef) => {
  const fallbackRef = useRef();
  const ref = canvasRef || fallbackRef;
  const [game, setGame] = useState();
  const [ready, setReady] = useState();
  const [activeScene, setActiveScene] = useState({});
  // const [activeSceneProps, setActiveSceneProps] = useState(null);

  useEffect(() => {
    const scenes = React.Children.map(
      children,
      (ch) =>
        new RPFScene(ch.props.name, ch.props.args, data => {
          // setActiveSceneProps(data)
          setActiveScene({ [ch.props.name]: data });
        })
    );
    // args.scene = [...scenes, ...(args.scene || [])];
    args.scene = [...(args.scene || []), ...scenes];
    args.callbacks = {
      postBoot: (game) => {
        setGame(game);
        setReady(true);
        game.scene.scenes.forEach((sc) => {
          sc.events.off(Phaser.Scenes.Events.READY);
          sc.events.once(Phaser.Scenes.Events.READY, () => {
            sc.events.off(Phaser.Scenes.Events.RENDER);
            sc.events.once(Phaser.Scenes.Events.RENDER, () => {
              // setActiveSceneKey(sc.scene.key);
            });
          });
          sc.events.once(Phaser.Scenes.Events.WAKE, () => {
            // console.log(Phaser.Scenes.Events.WAKE, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.UPDATE, () => {
            // console.log(Phaser.Scenes.Events.UPDATE, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.TRANSITION_WAKE, () => {
            // console.log(Phaser.Scenes.Events.TRANSITION_WAKE, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.TRANSITION_START, () => {
            // console.log(Phaser.Scenes.Events.TRANSITION_START, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.TRANSITION_OUT, () => {
            // console.log(Phaser.Scenes.Events.TRANSITION_OUT, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.TRANSITION_INIT, () => {
            // console.log(Phaser.Scenes.Events.TRANSITION_INIT, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.TRANSITION_COMPLETE, () => {
            // console.log(Phaser.Scenes.Events.TRANSITION_COMPLETE, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.START, () => {
            // console.log(Phaser.Scenes.Events.START, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.SLEEP, () => {
            // console.log(Phaser.Scenes.Events.SLEEP, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
            // console.log(Phaser.Scenes.Events.SHUTDOWN, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.RESUME, () => {
            // console.log(Phaser.Scenes.Events.RESUME, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.RENDER, () => {
            // console.log(Phaser.Scenes.Events.RENDER, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.READY, () => {
            // console.log(Phaser.Scenes.Events.READY, sc.scene.key)
          });
          sc.events.once(Phaser.Scenes.Events.PRE_RENDER, () => {
            // setActiveSceneKey(sc.scene.key);
            // console.log(Phaser.Scenes.Events.PRE_RENDER, sc.scene.key);
          });
          sc.events.once(Phaser.Scenes.Events.PAUSE, () => {
            // console.log(Phaser.Scenes.Events.PAUSE, sc.scene.key)
          });
          sc.events.on(Phaser.Scenes.Events.CREATE, () => {
            setActiveScene(state => ({ [sc.scene.key]: state[sc.scene.key] }));
            // setActiveSceneKey(sc.scene.key);
          });
          sc.events.once(Phaser.Scenes.Events.BOOT, () => {
            // console.log(Phaser.Scenes.Events.BOOT, sc.scene.key)
          });
        });
        // game.scene.scenes[0].events.once(Phaser.Scenes.Events.PRE_RENDER, (s) => {
        //   game.scene.scenes[0].load.on(Phaser.Loader.Events.COMPLETE, () =>
        //   setReady(true)
        //   );
        // });
      },
    };
    const game = new Phaser.Game(args);
    ref.current = game;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const activeChildren = React.Children.toArray(children).find((ch) => {
    return ch.props.name === Object.keys(activeScene)[0];
  });
  
  return ready ? (
    <PhaserProvider scene={game.scene.getScene(Object.keys(activeScene)[0])} sceneProps={Object.values(activeScene)[0]} game={game}>{activeChildren}</PhaserProvider>
  ) : null;
});

Canvas.displayName = "Canvas";
export default Canvas;
